import { useMemo } from 'preact/hooks';
import { Service, ServiceContent } from '@/base-api/types';
import { Button } from '@/components/button';
import { Card } from '@/components/card';
import { Image } from '@/components/image';
import { useServiceStore } from '@/contexts/service-context';
import { useInfoModal } from '@/hooks/useInfoModal';
import { formatCurrency } from '@/utils/number';

interface PdpWidgetInnerInput {
  serviceContent: ServiceContent;
  service: Service;
}

export function PdpWidgetInner({
  serviceContent,
  service,
}: PdpWidgetInnerInput) {
  const { activeOfferingByServiceId, setActiveOfferingByServiceId } =
    useServiceStore();
  const { offerings, name, id: serviceId } = service;

  const openInfoModal = useInfoModal(serviceContent.info_modal);

  const currentActiveOfferingId = useMemo(
    () => activeOfferingByServiceId[serviceId],
    [activeOfferingByServiceId, serviceId],
  );

  const { heading_image, heading, body, info_modal_trigger } =
    serviceContent.product_cta;

  return (
    <Card className="pdp-widget-inner">
      <div className="pdp-widget-header">
        {heading_image && (
          <div className="pdp-widget-header-image">
            <Image src={heading_image} alt={name} />
          </div>
        )}
        <p
          dangerouslySetInnerHTML={{
            __html: heading,
          }}
        ></p>
      </div>
      <div className="pdp-widget-body">
        {body && <p>{body}</p>}
        {info_modal_trigger && (
          <Button variant="link" onClick={openInfoModal}>
            {info_modal_trigger}
          </Button>
        )}
      </div>
      <div className="button-group" data-button-count={offerings.length}>
        {offerings.map((offering) => {
          const isActive = currentActiveOfferingId === offering.id;
          return (
            <Button
              variant="outline"
              key={offering.id}
              active={isActive}
              onClick={() =>
                setActiveOfferingByServiceId(serviceId, offering.id)
              }
            >
              <span className="pdp-widget-offer-name">{offering.name}:</span>
              <span className="pdp-widget-offer-price">
                {formatCurrency(offering.price)}
              </span>
            </Button>
          );
        })}
      </div>
    </Card>
  );
}
